module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-development"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coverageDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB pr. opgavetype\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.progress_percent === 0 || props.row.progress_percent > -5 && props.row.progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_avg') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_avg)) + "\n                            ")]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 708878618)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _vm._e()], 1)]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c73c961", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c73c961"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/components/projectTypeDevelopment.vue
// module id = 854
// module chunks = 0